webpackJsonp([1],{

/***/ 126:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_resource__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_es_components__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(313);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_es_components__["g" /* Modal */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_es_components__["a" /* Button */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_es_components__["c" /* Form */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_es_components__["e" /* Layout */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_es_components__["b" /* Card */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_es_components__["h" /* Table */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_es_components__["d" /* Image */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_es_components__["f" /* Media */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('Detail', __webpack_require__(95).default, {
  props: ['id', 'productId', 'product'],
  created: function created() {
    console.log('Detail props', this);
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('focus', {
  inserted: function inserted(el) {
    el.focus();
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ 129:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(63);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7340010c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(132);
function injectStyle (ssrContext) {
  __webpack_require__(130)
}
var normalizeComponent = __webpack_require__(23)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7340010c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 130:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container"},[_c('main',[_c('router-view')],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('div',[_c('span',[_c('i',{staticClass:"fas fa-shopping-cart cart-man"}),_vm._v("fjarkaup.is")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Search__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Detail__ = __webpack_require__(95);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Search',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Search__["a" /* default */]
  }, {
    path: '/Detail/:id',
    name: 'Detail',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Detail__["default"]
  }]
}));

/***/ }),

/***/ 135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__(64);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ebdda28_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__(205);
function injectStyle (ssrContext) {
  __webpack_require__(136)
}
var normalizeComponent = __webpack_require__(23)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1ebdda28"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ebdda28_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 136:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 159:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_mock_searchMockApi__ = __webpack_require__(178);




var url = 'https://test-api.fjarkaup.is/SearchService/products/search';
var qs = __webpack_require__(195);

var searchApi = {
  search: function search(payload) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url, {
      params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, payload),
      paramsSerializer: function paramsSerializer(params) {
        return qs.stringify(params, { indices: false });
      }
    }).catch(function (error) {
      console.error(error);
    });
  }
};

var api = searchApi;
try {
  var useMock = "production" === 'development' && Object({"NODE_ENV":"production","API_SEARCH_URL":'https://test-api.fjarkaup.is/SearchService/products/search',"API_PRODUCT_URL":'https://test-api.fjarkaup.is/ProductService',"API_CURRENCY_URL":"https://apis.is/currency"}).API_USE_MOCK === true;
  api = useMock ? __WEBPACK_IMPORTED_MODULE_2__api_mock_searchMockApi__["a" /* default */] : searchApi;
} catch (e) {
  console.error('error!');
}

/* harmony default export */ __webpack_exports__["a"] = (api);

/***/ }),

/***/ 178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_searchResult__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_searchResult___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__data_searchResult__);



var delay = function delay(ms) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    return setTimeout(resolve, ms);
  });
};
var shouldReject = false;

/* harmony default export */ __webpack_exports__["a"] = ({
  search: function search(searchPayload) {
    console.log('** search mock **', searchPayload);
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      delay(700).then(function () {
        if (shouldReject) {
          console.error('rejected', reject);
        } else {
          return resolve(__WEBPACK_IMPORTED_MODULE_1__data_searchResult___default.a);
        }
      });
    });
  }
});

/***/ }),

/***/ 194:
/***/ (function(module, exports) {

module.exports = {"data":[{"currencyCode":"USD","discount":46,"estimatedTotalPriceLcy":{"TaxInfo":{"amount":466,"percentage":24},"amountBeforeTaxes":1939,"exchangeRateInfo":{"currencyCode":"ISK","rate":103.0738},"totalAmountAfterTaxes":2405},"id":"32836485367","image":"https://ae01.alicdn.com/kf/HTB1C7Dcc3jN8KJjSZFCq6z3GpXat/Zapatillas-Hombre-Spring-Autumn-Winter-Men-Casual-Shoes-Breathable-Warm-Pu-Leather-Upper-Durable-Rubber-Outsole.jpg","images":["https://ae01.alicdn.com/kf/HTB1C7Dcc3jN8KJjSZFCq6z3GpXat/Zapatillas-Hombre-Spring-Autumn-Winter-Men-Casual-Shoes-Breathable-Warm-Pu-Leather-Upper-Durable-Rubber-Outsole.jpg","https://ae01.alicdn.com/kf/HTB1Jsy2mqmgSKJjSsplq6yICpXaP/Zapatillas-Hombre-Spring-Autumn-Winter-Men-Casual-Shoes-Breathable-Warm-Pu-Leather-Upper-Durable-Rubber-Outsole.jpg","https://ae01.alicdn.com/kf/HTB1KuwCqrsTMeJjy1zcq6xAgXXa3/Zapatillas-Hombre-Spring-Autumn-Winter-Men-Casual-Shoes-Breathable-Warm-Pu-Leather-Upper-Durable-Rubber-Outsole.jpg","https://ae01.alicdn.com/kf/HTB1jq8fqHsTMeJjSszhq6AGCFXai/Zapatillas-Hombre-Spring-Autumn-Winter-Men-Casual-Shoes-Breathable-Warm-Pu-Leather-Upper-Durable-Rubber-Outsole.jpg","https://ae01.alicdn.com/kf/HTB1rt5JmzihSKJjy0Feq6zJtpXam/Zapatillas-Hombre-Spring-Autumn-Winter-Men-Casual-Shoes-Breathable-Warm-Pu-Leather-Upper-Durable-Rubber-Outsole.jpg","https://ae01.alicdn.com/kf/HTB1vdbwmzihSKJjy0Flq6ydEXXag/Zapatillas-Hombre-Spring-Autumn-Winter-Men-Casual-Shoes-Breathable-Warm-Pu-Leather-Upper-Durable-Rubber-Outsole.jpg"],"orderCount":7,"originalPrice":34.83,"providerId":1,"salePrice":18.81,"title":"Zapatillas Hombre Spring Autumn Winter Men Casual Shoes Breathable Warm Pu Leather Upper Durable Rubber Outsole Lace-up <font><b>Foo</b></font>","url":"https://www.aliexpress.com/item/Zapatillas-Hombre-Spring-Autumn-Winter-Men-Casual-Shoes-Breathable-Warm-Pu-Leather-Upper-Durable-Rubber-Outsole/32836485367.html"},{"currencyCode":"USD","discount":5,"estimatedTotalPriceLcy":{"TaxInfo":{"amount":1878,"percentage":24},"amountBeforeTaxes":7825,"exchangeRateInfo":{"currencyCode":"ISK","rate":103.0738},"totalAmountAfterTaxes":9703},"id":"32862501849","image":"https://ae01.alicdn.com/kf/HTB1.g6clAyWBuNjy0Fpq6yssXXap/Modern-creative-French-bulldog-dog-sculpture-PE-plastic-pet-dog-statue-cute-animal-font-b-foo.jpg","images":["https://ae01.alicdn.com/kf/HTB1.g6clAyWBuNjy0Fpq6yssXXap/Modern-creative-French-bulldog-dog-sculpture-PE-plastic-pet-dog-statue-cute-animal-font-b-foo.jpg","https://ae01.alicdn.com/kf/HTB1RuI7c77mBKNjSZFyq6zydFXaE/Modern-creative-French-bulldog-dog-sculpture-PE-plastic-pet-dog-statue-cute-animal-font-b-foo.jpg","https://ae01.alicdn.com/kf/HTB1UEyGlxSYBuNjSsphq6zGvVXaQ/Modern-creative-French-bulldog-dog-sculpture-PE-plastic-pet-dog-statue-cute-animal-font-b-foo.jpg","https://ae01.alicdn.com/kf/HTB1ium3lpuWBuNjSspnq6x1NVXaS/Modern-creative-French-bulldog-dog-sculpture-PE-plastic-pet-dog-statue-cute-animal-font-b-foo.jpg","https://ae01.alicdn.com/kf/HTB1oZlTdiCYBuNkHFCcq6AHtVXaw/Modern-creative-French-bulldog-dog-sculpture-PE-plastic-pet-dog-statue-cute-animal-font-b-foo.jpg","https://ae01.alicdn.com/kf/HTB19hrclAyWBuNjy0Fpq6yssXXaL/Modern-creative-French-bulldog-dog-sculpture-PE-plastic-pet-dog-statue-cute-animal-font-b-foo.jpg"],"orderCount":0,"originalPrice":79.9,"providerId":1,"salePrice":75.91,"title":"Modern creative French bulldog dog sculpture PE plastic pet dog statue cute animal <font><b>foo</b></font> dog figurine Home Decorations Handicrafts","url":"https://www.aliexpress.com/item/Modern-creative-French-bulldog-dog-sculpture-PE-plastic-pet-dog-statue-cute-animal-foo-dog-figurine/32862501849.html"},{"currencyCode":"USD","discount":11,"estimatedTotalPriceLcy":{"TaxInfo":{"amount":1541,"percentage":24},"amountBeforeTaxes":6421,"exchangeRateInfo":{"currencyCode":"ISK","rate":103.0738},"totalAmountAfterTaxes":7962},"id":"32767294028","image":"https://ae01.alicdn.com/kf/HTB1.kg9OXXXXXXuXFXXq6xXFXXXN/Chinese-Boxwood-Wood-Carving-Fengshui-Lion-Fu-font-b-Foo-b-font-Dog-Guardion-Beast-Statue.jpg","images":["https://ae01.alicdn.com/kf/HTB1.kg9OXXXXXXuXFXXq6xXFXXXN/Chinese-Boxwood-Wood-Carving-Fengshui-Lion-Fu-font-b-Foo-b-font-Dog-Guardion-Beast-Statue.jpg","https://ae01.alicdn.com/kf/HTB1NpUDOXXXXXb1aFXXq6xXFXXXy/Chinese-Boxwood-Wood-Carving-Fengshui-Lion-Fu-font-b-Foo-b-font-Dog-Guardion-Beast-Statue.jpg","https://ae01.alicdn.com/kf/HTB12r.NOXXXXXbGaXXXq6xXFXXXk/Chinese-Boxwood-Wood-Carving-Fengshui-Lion-Fu-font-b-Foo-b-font-Dog-Guardion-Beast-Statue.jpg","https://ae01.alicdn.com/kf/HTB1CxA1OXXXXXaNXVXXq6xXFXXX8/Chinese-Boxwood-Wood-Carving-Fengshui-Lion-Fu-font-b-Foo-b-font-Dog-Guardion-Beast-Statue.jpg","https://ae01.alicdn.com/kf/HTB1YnwQOXXXXXbDaXXXq6xXFXXXS/Chinese-Boxwood-Wood-Carving-Fengshui-Lion-Fu-font-b-Foo-b-font-Dog-Guardion-Beast-Statue.jpg","https://ae01.alicdn.com/kf/HTB1bZo4OXXXXXXbXVXXq6xXFXXXl/Chinese-Boxwood-Wood-Carving-Fengshui-Lion-Fu-font-b-Foo-b-font-Dog-Guardion-Beast-Statue.jpg"],"orderCount":0,"originalPrice":69.99,"providerId":1,"salePrice":62.29,"title":"Chinese Boxwood Wood Carving Fengshui Lion Fu <font><b>Foo</b></font> Dog Guardion Beast Statue Pair","url":"https://www.aliexpress.com/item/Chinese-Boxwood-Wood-Carving-Fengshui-Lion-Fu-Foo-Dog-Guardion-Beast-Statue-Pair/32767294028.html"},{"currencyCode":"USD","discount":11,"estimatedTotalPriceLcy":{"TaxInfo":{"amount":661,"percentage":24},"amountBeforeTaxes":2752,"exchangeRateInfo":{"currencyCode":"ISK","rate":103.0738},"totalAmountAfterTaxes":3412},"id":"32507923235","image":"https://ae01.alicdn.com/kf/HTB13aSyKXXXXXc5XpXXq6xXFXXXg/Chinese-Silver-FengShui-Guard-font-b-Foo-b-font-Fu-Dog-Lion-Unicorn-PiXiu-Statue-Pair.jpg","images":["https://ae01.alicdn.com/kf/HTB13aSyKXXXXXc5XpXXq6xXFXXXg/Chinese-Silver-FengShui-Guard-font-b-Foo-b-font-Fu-Dog-Lion-Unicorn-PiXiu-Statue-Pair.jpg","https://ae01.alicdn.com/kf/HTB131uuKXXXXXXLXFXXq6xXFXXXa/Chinese-Silver-FengShui-Guard-font-b-Foo-b-font-Fu-Dog-Lion-Unicorn-PiXiu-Statue-Pair.jpg","https://ae01.alicdn.com/kf/HTB1AHWsKXXXXXaMXFXXq6xXFXXXs/Chinese-Silver-FengShui-Guard-font-b-Foo-b-font-Fu-Dog-Lion-Unicorn-PiXiu-Statue-Pair.jpg","https://ae01.alicdn.com/kf/HTB14SezKXXXXXcaXpXXq6xXFXXXS/Chinese-Silver-FengShui-Guard-font-b-Foo-b-font-Fu-Dog-Lion-Unicorn-PiXiu-Statue-Pair.jpg","https://ae01.alicdn.com/kf/HTB1k6mhKXXXXXa0XVXXq6xXFXXXT/Chinese-Silver-FengShui-Guard-font-b-Foo-b-font-Fu-Dog-Lion-Unicorn-PiXiu-Statue-Pair.jpg"],"orderCount":0,"originalPrice":29.99,"providerId":1,"salePrice":26.69,"title":"Chinese Silver FengShui Guard <font><b>Foo</b></font> Fu Dog Lion Unicorn PiXiu Statue Pair Set","url":"https://www.aliexpress.com/item/Chinese-Silver-FengShui-Guard-Foo-Fu-Dog-Lion-Unicorn-PiXiu-Statue-Pair-Set/32507923235.html"},{"currencyCode":"USD","discount":11,"estimatedTotalPriceLcy":{"TaxInfo":{"amount":2642,"percentage":24},"amountBeforeTaxes":11008,"exchangeRateInfo":{"currencyCode":"ISK","rate":103.0738},"totalAmountAfterTaxes":13649},"id":"32464478390","image":"https://ae01.alicdn.com/kf/HTB1obzUJpXXXXbvXVXXq6xXFXXXh/A-Pair-Chinese-Cloisonne-Copper-Statue-Lion-font-b-Foo-b-font-Dog.jpg","images":["https://ae01.alicdn.com/kf/HTB1obzUJpXXXXbvXVXXq6xXFXXXh/A-Pair-Chinese-Cloisonne-Copper-Statue-Lion-font-b-Foo-b-font-Dog.jpg","https://ae01.alicdn.com/kf/HTB1WiL8JpXXXXb_XpXXq6xXFXXXL/A-Pair-Chinese-Cloisonne-Copper-Statue-Lion-font-b-Foo-b-font-Dog.jpg","https://ae01.alicdn.com/kf/HTB1SxgkJpXXXXXsXXXXq6xXFXXXR/A-Pair-Chinese-Cloisonne-Copper-Statue-Lion-font-b-Foo-b-font-Dog.jpg","https://ae01.alicdn.com/kf/HTB1uSUjJpXXXXX_XXXXq6xXFXXXJ/A-Pair-Chinese-Cloisonne-Copper-Statue-Lion-font-b-Foo-b-font-Dog.jpg","https://ae01.alicdn.com/kf/HTB1fOMdJpXXXXcyXXXXq6xXFXXXl/A-Pair-Chinese-Cloisonne-Copper-Statue-Lion-font-b-Foo-b-font-Dog.jpg"],"orderCount":0,"originalPrice":119.99,"providerId":1,"salePrice":106.79,"title":"A Pair Chinese Cloisonne Copper Statue - Lion <font><b>Foo</b></font> Dog","url":"https://www.aliexpress.com/item/A-Pair-Chinese-Cloisonne-Copper-Statue-Lion-Foo-Dog/32464478390.html"},{"currencyCode":"USD","discount":11,"estimatedTotalPriceLcy":{"TaxInfo":{"amount":2642,"percentage":24},"amountBeforeTaxes":11008,"exchangeRateInfo":{"currencyCode":"ISK","rate":103.0738},"totalAmountAfterTaxes":13649},"id":"32459730247","image":"https://ae01.alicdn.com/kf/HTB1I9SMJpXXXXXIXFXXq6xXFXXXU/A-Pair-Chinese-Cloisonne-Copper-Statue-Lion-font-b-Foo-b-font-Dog-statue-Decoration-Ornament.jpg","images":["https://ae01.alicdn.com/kf/HTB1I9SMJpXXXXXIXFXXq6xXFXXXU/A-Pair-Chinese-Cloisonne-Copper-Statue-Lion-font-b-Foo-b-font-Dog-statue-Decoration-Ornament.jpg","https://ae01.alicdn.com/kf/HTB1z7yQJpXXXXb2XpXXq6xXFXXXO/A-Pair-Chinese-Cloisonne-Copper-Statue-Lion-font-b-Foo-b-font-Dog-statue-Decoration-Ornament.jpg","https://ae01.alicdn.com/kf/HTB1CVaSJpXXXXagXpXXq6xXFXXXU/A-Pair-Chinese-Cloisonne-Copper-Statue-Lion-font-b-Foo-b-font-Dog-statue-Decoration-Ornament.jpg","https://ae01.alicdn.com/kf/HTB1hqODJpXXXXaJXVXXq6xXFXXXr/A-Pair-Chinese-Cloisonne-Copper-Statue-Lion-font-b-Foo-b-font-Dog-statue-Decoration-Ornament.jpg"],"orderCount":0,"originalPrice":119.99,"providerId":1,"salePrice":106.79,"title":"A Pair Chinese Cloisonne Copper Statue-Lion <font><b>Foo</b></font> Dog statue Decoration Ornament","url":"https://www.aliexpress.com/item/A-Pair-Chinese-Cloisonne-Copper-Statue-Lion-Foo-Dog-statue-Decoration-Ornament/32459730247.html"},{"currencyCode":"USD","discount":11,"estimatedTotalPriceLcy":{"TaxInfo":{"amount":4404,"percentage":24},"amountBeforeTaxes":18347,"exchangeRateInfo":{"currencyCode":"ISK","rate":103.0738},"totalAmountAfterTaxes":22750},"id":"32543013005","image":"https://ae01.alicdn.com/kf/HTB1fH5AKFXXXXbgXXXXq6xXFXXXc/A-Pair-of-Chinese-Silver-Guardian-Lion-font-b-Foo-b-font-Fu-Dog-Statues.jpg","images":["https://ae01.alicdn.com/kf/HTB1fH5AKFXXXXbgXXXXq6xXFXXXc/A-Pair-of-Chinese-Silver-Guardian-Lion-font-b-Foo-b-font-Fu-Dog-Statues.jpg","https://ae01.alicdn.com/kf/HTB1JSCkKFXXXXajXFXXq6xXFXXXV/A-Pair-of-Chinese-Silver-Guardian-Lion-font-b-Foo-b-font-Fu-Dog-Statues.jpg","https://ae01.alicdn.com/kf/HTB1yeKiKFXXXXbFXFXXq6xXFXXXI/A-Pair-of-Chinese-Silver-Guardian-Lion-font-b-Foo-b-font-Fu-Dog-Statues.jpg","https://ae01.alicdn.com/kf/HTB1LxieKFXXXXXjXVXXq6xXFXXXQ/A-Pair-of-Chinese-Silver-Guardian-Lion-font-b-Foo-b-font-Fu-Dog-Statues.jpg","https://ae01.alicdn.com/kf/HTB1k51iKFXXXXa6XFXXq6xXFXXXo/A-Pair-of-Chinese-Silver-Guardian-Lion-font-b-Foo-b-font-Fu-Dog-Statues.jpg"],"orderCount":0,"originalPrice":199.99,"providerId":1,"salePrice":177.99,"title":"A Pair of Chinese Silver Guardian Lion <font><b>Foo</b></font> Fu Dog Statues","url":"https://www.aliexpress.com/item/Rare-Chinese-Silver-Guardian-Lion-Foo-Fu-Dog-Statue-Pair/32543013005.html"},{"currencyCode":"USD","discount":11,"estimatedTotalPriceLcy":{"TaxInfo":{"amount":8146,"percentage":24},"amountBeforeTaxes":33942,"exchangeRateInfo":{"currencyCode":"ISK","rate":103.0738},"totalAmountAfterTaxes":42088},"id":"32648134229","image":"https://ae01.alicdn.com/kf/HTB1JKmdMpXXXXaJXXXXq6xXFXXXq/33-cm--A-Pair-of-Exquisite-Chinese-White-Porcelain-Fengshui-font-b-Foo-b-font.jpg","images":["https://ae01.alicdn.com/kf/HTB1JKmdMpXXXXaJXXXXq6xXFXXXq/33-cm--A-Pair-of-Exquisite-Chinese-White-Porcelain-Fengshui-font-b-Foo-b-font.jpg","https://ae01.alicdn.com/kf/HTB1StWfMpXXXXXRXXXXq6xXFXXXD/33-cm--A-Pair-of-Exquisite-Chinese-White-Porcelain-Fengshui-font-b-Foo-b-font.jpg","https://ae01.alicdn.com/kf/HTB1yYVVMpXXXXbjXFXXq6xXFXXXk/33-cm--A-Pair-of-Exquisite-Chinese-White-Porcelain-Fengshui-font-b-Foo-b-font.jpg","https://ae01.alicdn.com/kf/HTB1vbX5MpXXXXbcXpXXq6xXFXXXa/33-cm--A-Pair-of-Exquisite-Chinese-White-Porcelain-Fengshui-font-b-Foo-b-font.jpg","https://ae01.alicdn.com/kf/HTB13_J5MpXXXXaKXpXXq6xXFXXXs/33-cm--A-Pair-of-Exquisite-Chinese-White-Porcelain-Fengshui-font-b-Foo-b-font.jpg","https://ae01.alicdn.com/kf/HTB1uc8.MpXXXXctXXXXq6xXFXXXC/33-cm--A-Pair-of-Exquisite-Chinese-White-Porcelain-Fengshui-font-b-Foo-b-font.jpg"],"orderCount":0,"originalPrice":369.99,"providerId":1,"salePrice":329.29,"title":"33 cm * / A Pair of Exquisite Chinese White Porcelain Fengshui <font><b>Foo</b></font> Fu Dog Guardion Lion statues","url":"https://www.aliexpress.com/item/33-cm-Chinese-White-Porcelain-Fengshui-Foo-Fu-Dog-Guardion-Lion-Pair-statue/32648134229.html"},{"currencyCode":"USD","discount":0,"estimatedTotalPriceLcy":{"TaxInfo":{"amount":164,"percentage":24},"amountBeforeTaxes":680,"exchangeRateInfo":{"currencyCode":"ISK","rate":103.0738},"totalAmountAfterTaxes":843},"id":"32824696844","image":"https://ae01.alicdn.com/kf/HTB1hYt9SFXXXXbmapXXq6xXFXXXI/SEWING-MACHINE-PARTS-PRESSER-FOOT-PFAFF-TEFLON-NONSYICK-PRESSER-font-b-FOO-b-font-820664096-PFAFF.jpg","images":["https://ae01.alicdn.com/kf/HTB1hYt9SFXXXXbmapXXq6xXFXXXI/SEWING-MACHINE-PARTS-PRESSER-FOOT-PFAFF-TEFLON-NONSYICK-PRESSER-font-b-FOO-b-font-820664096-PFAFF.jpg","https://ae01.alicdn.com/kf/HTB1ezSxSFXXXXXBXVXXq6xXFXXX7/SEWING-MACHINE-PARTS-PRESSER-FOOT-PFAFF-TEFLON-NONSYICK-PRESSER-font-b-FOO-b-font-820664096-PFAFF.jpg","https://ae01.alicdn.com/kf/HTB1gGCvSFXXXXaBXVXXq6xXFXXX1/SEWING-MACHINE-PARTS-PRESSER-FOOT-PFAFF-TEFLON-NONSYICK-PRESSER-font-b-FOO-b-font-820664096-PFAFF.jpg"],"orderCount":0,"originalPrice":6.59,"providerId":1,"salePrice":6.59,"title":"SEWING MACHINE PARTS PRESSER FOOT #PFAFF TEFLON NONSYICK PRESSER <font><b>FOO</b></font># 820664096 PFAFF IDT DUAL FEED","url":"https://www.aliexpress.com/item/SEWING-MACHINE-PARTS-PRESSER-FOOT-PFAFF-TEFLON-NONSYICK-PRESSER-FOO-820664096-PFAFF-IDT-DUAL-FEED/32824696844.html"},{"currencyCode":"USD","discount":12,"estimatedTotalPriceLcy":{"TaxInfo":{"amount":176,"percentage":24},"amountBeforeTaxes":730,"exchangeRateInfo":{"currencyCode":"ISK","rate":103.0738},"totalAmountAfterTaxes":905},"id":"32862799615","image":"https://ae01.alicdn.com/kf/HTB1QoYdiwmTBuNjy1Xbq6yMrVXa0/Kitchen-Cereal-Dry-Food-Storage-Container-Airtight-Lid-Suitable-For-Cereal-Flour-Sugar-Coffee-Rice-Snacks.jpg","images":["https://ae01.alicdn.com/kf/HTB1QoYdiwmTBuNjy1Xbq6yMrVXa0/Kitchen-Cereal-Dry-Food-Storage-Container-Airtight-Lid-Suitable-For-Cereal-Flour-Sugar-Coffee-Rice-Snacks.jpg","https://ae01.alicdn.com/kf/HTB1Wc25iv1TBuNjy0Fjq6yjyXXaY/Kitchen-Cereal-Dry-Food-Storage-Container-Airtight-Lid-Suitable-For-Cereal-Flour-Sugar-Coffee-Rice-Snacks.jpg","https://ae01.alicdn.com/kf/HTB1tNZecnmWBKNjSZFBq6xxUFXaH/Kitchen-Cereal-Dry-Food-Storage-Container-Airtight-Lid-Suitable-For-Cereal-Flour-Sugar-Coffee-Rice-Snacks.jpg","https://ae01.alicdn.com/kf/HTB104pGiTJYBeNjy1zeq6yhzVXae/Kitchen-Cereal-Dry-Food-Storage-Container-Airtight-Lid-Suitable-For-Cereal-Flour-Sugar-Coffee-Rice-Snacks.jpg","https://ae01.alicdn.com/kf/HTB14gT9ir1YBuNjSszhq6AUsFXaq/Kitchen-Cereal-Dry-Food-Storage-Container-Airtight-Lid-Suitable-For-Cereal-Flour-Sugar-Coffee-Rice-Snacks.jpg","https://ae01.alicdn.com/kf/HTB1pV_kiuuSBuNjSsplq6ze8pXae/Kitchen-Cereal-Dry-Food-Storage-Container-Airtight-Lid-Suitable-For-Cereal-Flour-Sugar-Coffee-Rice-Snacks.jpg"],"orderCount":0,"originalPrice":8.04,"providerId":1,"salePrice":7.08,"title":"Kitchen Cereal & Dry Food Storage Container - Airtight Lid - Suitable For Cereal, Flour, Sugar, Coffee, Rice, Snacks, Pet <font><b>Foo</b></font>","url":"https://www.aliexpress.com/item/Kitchen-Cereal-Dry-Food-Storage-Container-Airtight-Lid-Suitable-For-Cereal-Flour-Sugar-Coffee-Rice-Snacks/32862799615.html"},{"currencyCode":"USD","discount":5,"estimatedTotalPriceLcy":{"TaxInfo":{"amount":78,"percentage":24},"amountBeforeTaxes":324,"exchangeRateInfo":{"currencyCode":"ISK","rate":103.0738},"totalAmountAfterTaxes":402},"id":"32858610198","image":"https://ae01.alicdn.com/kf/HTB1fE_ieER1BeNjy0Fmq6z0wVXaD/New-Cute-Half-a-lemon-Squishy-Slow-Rising-Cell-Phone-Strap-Bread-Anti-stress-ball-Scented.jpg","images":["https://ae01.alicdn.com/kf/HTB1fE_ieER1BeNjy0Fmq6z0wVXaD/New-Cute-Half-a-lemon-Squishy-Slow-Rising-Cell-Phone-Strap-Bread-Anti-stress-ball-Scented.jpg","https://ae01.alicdn.com/kf/HTB1pbFWeuuSBuNjSsplq6ze8pXam/New-Cute-Half-a-lemon-Squishy-Slow-Rising-Cell-Phone-Strap-Bread-Anti-stress-ball-Scented.jpg","https://ae01.alicdn.com/kf/HTB1v3h8er1YBuNjSszeq6yblFXa3/New-Cute-Half-a-lemon-Squishy-Slow-Rising-Cell-Phone-Strap-Bread-Anti-stress-ball-Scented.jpg","https://ae01.alicdn.com/kf/HTB1Wc3laYArBKNjSZFLq6A_dVXad/New-Cute-Half-a-lemon-Squishy-Slow-Rising-Cell-Phone-Strap-Bread-Anti-stress-ball-Scented.jpg","https://ae01.alicdn.com/kf/HTB1f_fHaYwrBKNjSZPcq6xpapXaV/New-Cute-Half-a-lemon-Squishy-Slow-Rising-Cell-Phone-Strap-Bread-Anti-stress-ball-Scented.jpg","https://ae01.alicdn.com/kf/HTB1KvQhaYorBKNjSZFjq6A_SpXak/New-Cute-Half-a-lemon-Squishy-Slow-Rising-Cell-Phone-Strap-Bread-Anti-stress-ball-Scented.jpg"],"orderCount":0,"originalPrice":3.31,"providerId":1,"salePrice":3.14,"title":"New Cute Half a lemon Squishy Slow Rising Cell Phone Strap Bread Anti stress ball Scented Key Pendant Kids Toys simulation <font><b>foo</b></font>","url":"https://www.aliexpress.com/item/New-Cute-Half-a-lemon-Squishy-Slow-Rising-Cell-Phone-Strap-Bread-Anti-stress-ball-Scented/32858610198.html"},{"currencyCode":"USD","discount":32,"estimatedTotalPriceLcy":{"TaxInfo":{"amount":269,"percentage":24},"amountBeforeTaxes":1121,"exchangeRateInfo":{"currencyCode":"ISK","rate":103.0738},"totalAmountAfterTaxes":1390},"id":"32522524647","image":"https://ae01.alicdn.com/kf/HTB12opaKpXXXXcqXVXXq6xXFXXXa/Smells-Like-the-90-s-T-Shirt-Nirvana-font-b-Foo-b-font-Fighters-Smashing-Pumpkins.jpg","images":["https://ae01.alicdn.com/kf/HTB12opaKpXXXXcqXVXXq6xXFXXXa/Smells-Like-the-90-s-T-Shirt-Nirvana-font-b-Foo-b-font-Fighters-Smashing-Pumpkins.jpg"],"orderCount":0,"originalPrice":15.99,"providerId":1,"salePrice":10.87,"title":"Smells Like the 90's T-Shirt Nirvana <font><b>Foo</b></font> Fighters Smashing Pumpkins Deftones Weezer Rock t shirt tops For Unisex Women Men","url":"https://www.aliexpress.com/item/Smells-Like-the-90-s-T-Shirt-Nirvana-Foo-Fighters-Smashing-Pumpkins-Deftones-Weezer-Rock-t/32522524647.html"},{"currencyCode":"USD","discount":43,"estimatedTotalPriceLcy":{"TaxInfo":{"amount":196,"percentage":24},"amountBeforeTaxes":816,"exchangeRateInfo":{"currencyCode":"ISK","rate":103.0738},"totalAmountAfterTaxes":1011},"id":"32753462889","image":"https://ae01.alicdn.com/kf/HTB10MnvSFXXXXbhXVXXq6xXFXXXu/Men-Fashion-T-Shirt-font-b-Foo-b-font-Fighters-T-Shirt-brand-Glamor-Best-Rock.jpg","images":["https://ae01.alicdn.com/kf/HTB10MnvSFXXXXbhXVXXq6xXFXXXu/Men-Fashion-T-Shirt-font-b-Foo-b-font-Fighters-T-Shirt-brand-Glamor-Best-Rock.jpg","https://ae01.alicdn.com/kf/HTB1FAYPSFXXXXazXpXXq6xXFXXXc/Men-Fashion-T-Shirt-font-b-Foo-b-font-Fighters-T-Shirt-brand-Glamor-Best-Rock.jpg","https://ae01.alicdn.com/kf/HTB1YLPrSFXXXXcrXVXXq6xXFXXXV/Men-Fashion-T-Shirt-font-b-Foo-b-font-Fighters-T-Shirt-brand-Glamor-Best-Rock.jpg","https://ae01.alicdn.com/kf/HTB1.9zQSFXXXXaOXpXXq6xXFXXXB/Men-Fashion-T-Shirt-font-b-Foo-b-font-Fighters-T-Shirt-brand-Glamor-Best-Rock.jpg","https://ae01.alicdn.com/kf/HTB1xvC6SFXXXXcpapXXq6xXFXXXj/Men-Fashion-T-Shirt-font-b-Foo-b-font-Fighters-T-Shirt-brand-Glamor-Best-Rock.jpg","https://ae01.alicdn.com/kf/HTB1UVYrSFXXXXbyXVXXq6xXFXXX3/Men-Fashion-T-Shirt-font-b-Foo-b-font-Fighters-T-Shirt-brand-Glamor-Best-Rock.jpg"],"orderCount":0,"originalPrice":13.88,"providerId":1,"salePrice":7.91,"title":"Men Fashion T Shirt <font><b>Foo</b></font> Fighters T-Shirt brand Glamor Best Rock Album loose sitcoms female T shirts","url":"https://www.aliexpress.com/item/Men-Fashion-T-Shirt-Foo-Fighters-T-Shirt-brand-Glamor-Best-Rock-Album-loose-sitcoms-female/32753462889.html"},{"currencyCode":"USD","discount":0,"estimatedTotalPriceLcy":{"TaxInfo":{"amount":36,"percentage":24},"amountBeforeTaxes":150,"exchangeRateInfo":{"currencyCode":"ISK","rate":103.0738},"totalAmountAfterTaxes":186},"id":"32836612610","image":"https://ae01.alicdn.com/kf/HTB105ylpbwTMeJjSszfq6xbtFXaT/1PC-Band-Bracelet-1-Wide-Band-font-b-Foo-b-font-Fighters-Silicone-Wristband-Gift-For.jpg","images":["https://ae01.alicdn.com/kf/HTB105ylpbwTMeJjSszfq6xbtFXaT/1PC-Band-Bracelet-1-Wide-Band-font-b-Foo-b-font-Fighters-Silicone-Wristband-Gift-For.jpg","https://ae01.alicdn.com/kf/HTB101w5k6ihSKJjy0Fiq6AuiFXaS/1PC-Band-Bracelet-1-Wide-Band-font-b-Foo-b-font-Fighters-Silicone-Wristband-Gift-For.jpg"],"orderCount":1,"originalPrice":1.45,"providerId":1,"salePrice":1.45,"title":"1PC Band Bracelet 1'' Wide Band <font><b>Foo</b></font> Fighters Silicone Wristband Gift For Friends","url":"https://www.aliexpress.com/item/1PC-Band-Bracelet-1-Wide-Band-Foo-Fighters-Silicone-Wristband-Gift-For-Friends/32836612610.html"},{"currencyCode":"USD","discount":36,"estimatedTotalPriceLcy":{"TaxInfo":{"amount":42,"percentage":24},"amountBeforeTaxes":172,"exchangeRateInfo":{"currencyCode":"ISK","rate":103.0738},"totalAmountAfterTaxes":213},"id":"32864741339","image":"https://ae01.alicdn.com/kf/HTB1ts3bnb5YBuNjSspoq6zeNFXa9/Lavaza-font-b-Foo-b-font-Fighters-Hard-Cover-Case-for-Samsung-Galaxy-J7-J1-J2.jpg","images":["https://ae01.alicdn.com/kf/HTB1ts3bnb5YBuNjSspoq6zeNFXa9/Lavaza-font-b-Foo-b-font-Fighters-Hard-Cover-Case-for-Samsung-Galaxy-J7-J1-J2.jpg","https://ae01.alicdn.com/kf/HTB1g0WUe8mWBuNkSndVq6AsApXar/Lavaza-font-b-Foo-b-font-Fighters-Hard-Cover-Case-for-Samsung-Galaxy-J7-J1-J2.jpg","https://ae01.alicdn.com/kf/HTB177UHnh9YBuNjy0Ffq6xIsVXa6/Lavaza-font-b-Foo-b-font-Fighters-Hard-Cover-Case-for-Samsung-Galaxy-J7-J1-J2.jpg","https://ae01.alicdn.com/kf/HTB1Qg.kneuSBuNjy1Xcq6AYjFXaS/Lavaza-font-b-Foo-b-font-Fighters-Hard-Cover-Case-for-Samsung-Galaxy-J7-J1-J2.jpg","https://ae01.alicdn.com/kf/HTB1Tk7Hnh9YBuNjy0Ffq6xIsVXar/Lavaza-font-b-Foo-b-font-Fighters-Hard-Cover-Case-for-Samsung-Galaxy-J7-J1-J2.jpg","https://ae01.alicdn.com/kf/HTB1ci3FdHZnBKNjSZFhq6A.oXXaT/Lavaza-font-b-Foo-b-font-Fighters-Hard-Cover-Case-for-Samsung-Galaxy-J7-J1-J2.jpg"],"orderCount":0,"originalPrice":2.59,"providerId":1,"salePrice":1.66,"title":"Lavaza <font><b>Foo</b></font> Fighters Hard Cover Case for Samsung Galaxy J7 J1 J2 J3 J5 2015 2016 2017 Prime Pro Ace 2018 Cases","url":"https://www.aliexpress.com/item/Lavaza-Foo-Fighters-Hard-Cover-Case-for-Samsung-Galaxy-J7-J1-J2-J3-J5-2015-2016/32864741339.html"},{"currencyCode":"USD","discount":36,"estimatedTotalPriceLcy":{"TaxInfo":{"amount":42,"percentage":24},"amountBeforeTaxes":172,"exchangeRateInfo":{"currencyCode":"ISK","rate":103.0738},"totalAmountAfterTaxes":213},"id":"32863170362","image":"https://ae01.alicdn.com/kf/HTB1U80Oc_dYBeNkSmLyq6xfnVXaF/Lavaza-font-b-Foo-b-font-Fighters-Hard-Phone-Case-for-Apple-iPhone-X-10-8.jpg","images":["https://ae01.alicdn.com/kf/HTB1U80Oc_dYBeNkSmLyq6xfnVXaF/Lavaza-font-b-Foo-b-font-Fighters-Hard-Phone-Case-for-Apple-iPhone-X-10-8.jpg","https://ae01.alicdn.com/kf/HTB12BvNkFGWBuNjy0Fbq6z4sXXaN/Lavaza-font-b-Foo-b-font-Fighters-Hard-Phone-Case-for-Apple-iPhone-X-10-8.jpg","https://ae01.alicdn.com/kf/HTB19vMrkQSWBuNjSszdq6zeSpXa3/Lavaza-font-b-Foo-b-font-Fighters-Hard-Phone-Case-for-Apple-iPhone-X-10-8.jpg","https://ae01.alicdn.com/kf/HTB1icf0kL5TBuNjSspcq6znGFXac/Lavaza-font-b-Foo-b-font-Fighters-Hard-Phone-Case-for-Apple-iPhone-X-10-8.jpg","https://ae01.alicdn.com/kf/HTB13DAQcJcnBKNjSZR0q6AFqFXaq/Lavaza-font-b-Foo-b-font-Fighters-Hard-Phone-Case-for-Apple-iPhone-X-10-8.jpg","https://ae01.alicdn.com/kf/HTB19OdOc8jTBKNjSZFNq6ysFXXad/Lavaza-font-b-Foo-b-font-Fighters-Hard-Phone-Case-for-Apple-iPhone-X-10-8.jpg"],"orderCount":0,"originalPrice":2.59,"providerId":1,"salePrice":1.66,"title":"Lavaza <font><b>Foo</b></font> Fighters Hard Phone Case for Apple iPhone X 10 8 7 6 6s Plus 5 5S SE 5C 4 4S Cover Coque Shell","url":"https://www.aliexpress.com/item/Lavaza-Foo-Fighters-Hard-Phone-Case-for-Apple-iPhone-X-10-8-7-6-6s-Plus/32863170362.html"},{"currencyCode":"USD","discount":36,"estimatedTotalPriceLcy":{"TaxInfo":{"amount":42,"percentage":24},"amountBeforeTaxes":172,"exchangeRateInfo":{"currencyCode":"ISK","rate":103.0738},"totalAmountAfterTaxes":213},"id":"32862197362","image":"https://ae01.alicdn.com/kf/HTB1ouFAleGSBuNjSspbq6AiipXa8/Lavaza-font-b-Foo-b-font-Fighters-Hard-Cover-Case-for-Samsung-Galaxy-S6-S7-Edge.jpg","images":["https://ae01.alicdn.com/kf/HTB1ouFAleGSBuNjSspbq6AiipXa8/Lavaza-font-b-Foo-b-font-Fighters-Hard-Cover-Case-for-Samsung-Galaxy-S6-S7-Edge.jpg","https://ae01.alicdn.com/kf/HTB1YklNlf5TBuNjSspmq6yDRVXaF/Lavaza-font-b-Foo-b-font-Fighters-Hard-Cover-Case-for-Samsung-Galaxy-S6-S7-Edge.jpg","https://ae01.alicdn.com/kf/HTB1LrNNlhSYBuNjSspjq6x73VXal/Lavaza-font-b-Foo-b-font-Fighters-Hard-Cover-Case-for-Samsung-Galaxy-S6-S7-Edge.jpg","https://ae01.alicdn.com/kf/HTB1i.9bc6QnBKNjSZSgq6xHGXXaE/Lavaza-font-b-Foo-b-font-Fighters-Hard-Cover-Case-for-Samsung-Galaxy-S6-S7-Edge.jpg","https://ae01.alicdn.com/kf/HTB1WJ8QlhWYBuNjy1zkq6xGGpXa8/Lavaza-font-b-Foo-b-font-Fighters-Hard-Cover-Case-for-Samsung-Galaxy-S6-S7-Edge.jpg","https://ae01.alicdn.com/kf/HTB1zCILkYSYBuNjSspiq6xNzpXa1/Lavaza-font-b-Foo-b-font-Fighters-Hard-Cover-Case-for-Samsung-Galaxy-S6-S7-Edge.jpg"],"orderCount":0,"originalPrice":2.59,"providerId":1,"salePrice":1.66,"title":"Lavaza <font><b>Foo</b></font> Fighters Hard Cover Case for Samsung Galaxy S6 S7 Edge S8 S9 Plus S3 S4 S5 Mini Case Shell","url":"https://www.aliexpress.com/item/Lavaza-Foo-Fighters-Hard-Cover-Case-for-Samsung-Galaxy-S6-S7-Edge-S8-S9-Plus-S3/32862197362.html"},{"currencyCode":"USD","discount":0,"estimatedTotalPriceLcy":{"TaxInfo":{"amount":245,"percentage":24},"amountBeforeTaxes":1020,"exchangeRateInfo":{"currencyCode":"ISK","rate":103.0738},"totalAmountAfterTaxes":1265},"id":"32839309365","image":"https://ae01.alicdn.com/kf/HTB19zVab_nI8KJjSszgq6A8ApXax/-font-b-FOO-b-font-FIGHTERS-CONCRETE-AND-GOLD-CD-NEW-CD-NEW-2017.jpg","images":["https://ae01.alicdn.com/kf/HTB19zVab_nI8KJjSszgq6A8ApXax/-font-b-FOO-b-font-FIGHTERS-CONCRETE-AND-GOLD-CD-NEW-CD-NEW-2017.jpg"],"orderCount":0,"originalPrice":9.89,"providerId":1,"salePrice":9.89,"title":"<font><b>FOO</b></font> FIGHTERS - CONCRETE AND GOLD - CD - NEW CD NEW 2017","url":"https://www.aliexpress.com/item/FOO-FIGHTERS-CONCRETE-AND-GOLD-CD-NEW-CD-NEW-2017/32839309365.html"},{"currencyCode":"USD","discount":0,"estimatedTotalPriceLcy":{"TaxInfo":{"amount":297,"percentage":24},"amountBeforeTaxes":1236,"exchangeRateInfo":{"currencyCode":"ISK","rate":103.0738},"totalAmountAfterTaxes":1533},"id":"32843816896","image":"https://ae01.alicdn.com/kf/HTB1eCgYXj7nBKNjSZLeq6zxCFXaA/c031-font-b-Foo-b-font-Fighters-Rock-n-Roll-Punk-Bar-Light-Sign.jpg","images":["https://ae01.alicdn.com/kf/HTB1eCgYXj7nBKNjSZLeq6zxCFXaA/c031-font-b-Foo-b-font-Fighters-Rock-n-Roll-Punk-Bar-Light-Sign.jpg"],"orderCount":0,"originalPrice":11.99,"providerId":1,"salePrice":11.99,"title":"c031 <font><b>Foo</b></font> Fighters Rock n Roll Punk Bar Light Sign","url":"https://www.aliexpress.com/item/c031-Foo-Fighters-Rock-n-Roll-Punk-Bar-Light-Sign/32843816896.html"},{"currencyCode":"USD","discount":0,"estimatedTotalPriceLcy":{"TaxInfo":{"amount":5781,"percentage":24},"amountBeforeTaxes":24085,"exchangeRateInfo":{"currencyCode":"ISK","rate":103.0738},"totalAmountAfterTaxes":29865},"id":"1402271159","image":"https://ae01.alicdn.com/kf/HTB1eQt3JVXXXXcfXXXXq6xXFXXXy/100-Real-Bronze-Dog-Sculptures-Statue-chinese-font-b-foo-b-font-dog-figurine-for-Home.jpg","images":["https://ae01.alicdn.com/kf/HTB1eQt3JVXXXXcfXXXXq6xXFXXXy/100-Real-Bronze-Dog-Sculptures-Statue-chinese-font-b-foo-b-font-dog-figurine-for-Home.jpg","https://ae01.alicdn.com/kf/HTB1_xVHJVXXXXcJXFXXq6xXFXXXG/100-Real-Bronze-Dog-Sculptures-Statue-chinese-font-b-foo-b-font-dog-figurine-for-Home.jpg","https://ae01.alicdn.com/kf/HTB1wE0zJVXXXXcTXVXXq6xXFXXXb/100-Real-Bronze-Dog-Sculptures-Statue-chinese-font-b-foo-b-font-dog-figurine-for-Home.jpg","https://ae01.alicdn.com/kf/HTB1PZxGJVXXXXXJXVXXq6xXFXXXU/100-Real-Bronze-Dog-Sculptures-Statue-chinese-font-b-foo-b-font-dog-figurine-for-Home.jpg","https://ae01.alicdn.com/kf/HTB1DHt5JVXXXXbjXXXXq6xXFXXX1/100-Real-Bronze-Dog-Sculptures-Statue-chinese-font-b-foo-b-font-dog-figurine-for-Home.jpg"],"orderCount":0,"originalPrice":233.66,"providerId":1,"salePrice":233.66,"title":"100% Real Bronze Dog Sculptures Statue chinese <font><b>foo</b></font> dog figurine for Home decoration chinese guard dogs CZW-064","url":"https://www.aliexpress.com/item/100-Real-Bronze-Modern-Dog-Sculptures-Statue-With-Marble-Base-CZW-064/1402271159.html"}]}

/***/ }),

/***/ 198:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_getProductResult__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_getProductResult___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__data_getProductResult__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_providerResult__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_providerResult___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__data_providerResult__);




var delay = function delay(ms) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    return setTimeout(resolve, ms);
  });
};
var shouldReject = false;

/* harmony default export */ __webpack_exports__["a"] = ({
  getProduct: function getProduct(productId, providerId) {
    console.log('** getProduct mock **', productId, providerId);
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      delay(1000).then(function () {
        if (shouldReject) {
          console.error('rejected', reject);
        } else {
          return resolve(__WEBPACK_IMPORTED_MODULE_1__data_getProductResult___default.a);
        }
      });
    });
  },
  getProviders: function getProviders() {
    console.log('** getProviders mock **');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      delay(1000).then(function () {
        if (shouldReject) {
          console.error('rejected', reject);
        } else {
          return resolve(__WEBPACK_IMPORTED_MODULE_2__data_providerResult___default.a);
        }
      });
    });
  }
});

/***/ }),

/***/ 199:
/***/ (function(module, exports) {

module.exports = {"data":{"description":"Zhiyun Smooth 4 Handheld 3-Axis Brushless Gimbal Stabilizer for iPhone X Xs for Samsung for gopro hero 7 6 PK DJI Osmo 2 Mobile","discount":29,"entryDate":"2018-11-30T00:00:00Z","id":"32857161002","image":"https://ae01.alicdn.com/kf/HTB1KPyFX16sK1RjSsrbq6xbDXXaF/Zhiyun-Smooth-4-Handheld-3-Axis-Brushless-Gimbal-Stabilizer-for-iPhone-X-Xs-for-Samsung-for.jpg","images":["https://ae01.alicdn.com/kf/HTB1KPyFX16sK1RjSsrbq6xbDXXaF/Zhiyun-Smooth-4-Handheld-3-Axis-Brushless-Gimbal-Stabilizer-for-iPhone-X-Xs-for-Samsung-for.jpg","https://ae01.alicdn.com/kf/HTB1KJT8mAZmBKNjSZPiq6xFNVXac/Zhiyun-Smooth-4-Handheld-3-Axis-Brushless-Gimbal-Stabilizer-for-iPhone-X-Xs-for-Samsung-for.jpg","https://ae01.alicdn.com/kf/HTB19IfEhDCWBKNjSZFtq6yC3FXa4/Zhiyun-Smooth-4-Handheld-3-Axis-Brushless-Gimbal-Stabilizer-for-iPhone-X-Xs-for-Samsung-for.jpg","https://ae01.alicdn.com/kf/HTB1lzP9vr5YBuNjSspoq6zeNFXan/Zhiyun-Smooth-4-Handheld-3-Axis-Brushless-Gimbal-Stabilizer-for-iPhone-X-Xs-for-Samsung-for.jpg","https://ae01.alicdn.com/kf/HTB18.ePx1uSBuNjy1Xcq6AYjFXav/Zhiyun-Smooth-4-Handheld-3-Axis-Brushless-Gimbal-Stabilizer-for-iPhone-X-Xs-for-Samsung-for.jpg","https://ae01.alicdn.com/kf/HTB1uLc0vv1TBuNjy0Fjq6yjyXXa0/Zhiyun-Smooth-4-Handheld-3-Axis-Brushless-Gimbal-Stabilizer-for-iPhone-X-Xs-for-Samsung-for.jpg"],"orderCount":0,"originalPrice":140,"productRating":4.5,"providerId":1,"salePrice":99.4,"storeName":"COOG TECH Store","storeURL":"https://www.aliexpress.com/store/913837","title":"Zhiyun Smooth 4 Handheld 3-Axis Brushless Gimbal Stabilizer for iPhone X Xs for Samsung for gopro hero 7 6 PK DJI Osmo 2 Mobile","url":"http://s.click.aliexpress.com/e/cSaoBEmy"}}

/***/ }),

/***/ 200:
/***/ (function(module, exports) {

module.exports = {"data":[{"icon":"M127.6,292.2c-1.2-0.8-2-2-2-3.7c-2-20.4-19.1-36.6-39.9-36.6s-38.3,15.9-39.9,36.6c0,1.2-0.8,2.8-2,3.7  c-10.2,7.3-17.1,19.1-17.1,32.6c0,18.3,12.6,34.2,29.7,38.7l0,0c2.8,0.8,6.1,1.2,6.9,0.4c2-1.2,4.9-11.4,3.7-13.4  c-0.8-1.2-3.3-2.4-6.5-3.3l0,0c-10.2-2.8-17.5-11.8-17.5-22.8c0-6.1,2.4-11.4,6.1-15.9c1.6-2,3.7-3.7,6.1-4.9  c4.5-2.4,6.9-6.9,6.9-11.8l0,0c0-2.4,0.4-4.9,1.2-7.3c3.3-9.4,11.8-16.3,22.4-16.3s19.1,6.9,22.4,16.3c0.8,2.4,1.2,4.9,1.2,7.3l0,0  c0,4.9,2.4,9.4,6.9,11.8c2.4,1.2,4.1,2.8,6.1,4.9c3.7,4.1,6.1,9.8,6.1,15.9c0,13-10.6,23.6-23.6,23.6c-15.1,0-26.9,12.2-26.9,27.3  v15.5c0,2.8,0.4,6.1,1.2,6.9c1.6,1.6,12.2,1.6,13.8,0c0.8-0.8,1.2-4.1,1.2-6.9l0,0v-15.9c0-5.7,4.9-10.6,10.6-10.6  c22,0,39.9-17.9,39.9-39.9C144.7,311.4,137.8,299.6,127.6,292.2z","id":1,"shortName":"AliExpress"},{"icon":"M127.6,292.2c-1.2-0.8-2-2-2-3.7c-2-20.4-19.1-36.6-39.9-36.6s-38.3,15.9-39.9,36.6c0,1.2-0.8,2.8-2,3.7  c-10.2,7.3-17.1,19.1-17.1,32.6c0,18.3,12.6,34.2,29.7,38.7l0,0c2.8,0.8,6.1,1.2,6.9,0.4c2-1.2,4.9-11.4,3.7-13.4  c-0.8-1.2-3.3-2.4-6.5-3.3l0,0c-10.2-2.8-17.5-11.8-17.5-22.8c0-6.1,2.4-11.4,6.1-15.9c1.6-2,3.7-3.7,6.1-4.9  c4.5-2.4,6.9-6.9,6.9-11.8l0,0c0-2.4,0.4-4.9,1.2-7.3c3.3-9.4,11.8-16.3,22.4-16.3s19.1,6.9,22.4,16.3c0.8,2.4,1.2,4.9,1.2,7.3l0,0  c0,4.9,2.4,9.4,6.9,11.8c2.4,1.2,4.1,2.8,6.1,4.9c3.7,4.1,6.1,9.8,6.1,15.9c0,13-10.6,23.6-23.6,23.6c-15.1,0-26.9,12.2-26.9,27.3  v15.5c0,2.8,0.4,6.1,1.2,6.9c1.6,1.6,12.2,1.6,13.8,0c0.8-0.8,1.2-4.1,1.2-6.9l0,0v-15.9c0-5.7,4.9-10.6,10.6-10.6  c22,0,39.9-17.9,39.9-39.9C144.7,311.4,137.8,299.6,127.6,292.2z","id":2,"shortName":"Etsy"},{"icon":"M127.6,292.2c-1.2-0.8-2-2-2-3.7c-2-20.4-19.1-36.6-39.9-36.6s-38.3,15.9-39.9,36.6c0,1.2-0.8,2.8-2,3.7  c-10.2,7.3-17.1,19.1-17.1,32.6c0,18.3,12.6,34.2,29.7,38.7l0,0c2.8,0.8,6.1,1.2,6.9,0.4c2-1.2,4.9-11.4,3.7-13.4  c-0.8-1.2-3.3-2.4-6.5-3.3l0,0c-10.2-2.8-17.5-11.8-17.5-22.8c0-6.1,2.4-11.4,6.1-15.9c1.6-2,3.7-3.7,6.1-4.9  c4.5-2.4,6.9-6.9,6.9-11.8l0,0c0-2.4,0.4-4.9,1.2-7.3c3.3-9.4,11.8-16.3,22.4-16.3s19.1,6.9,22.4,16.3c0.8,2.4,1.2,4.9,1.2,7.3l0,0  c0,4.9,2.4,9.4,6.9,11.8c2.4,1.2,4.1,2.8,6.1,4.9c3.7,4.1,6.1,9.8,6.1,15.9c0,13-10.6,23.6-23.6,23.6c-15.1,0-26.9,12.2-26.9,27.3  v15.5c0,2.8,0.4,6.1,1.2,6.9c1.6,1.6,12.2,1.6,13.8,0c0.8-0.8,1.2-4.1,1.2-6.9l0,0v-15.9c0-5.7,4.9-10.6,10.6-10.6  c22,0,39.9-17.9,39.9-39.9C144.7,311.4,137.8,299.6,127.6,292.2z","id":3,"shortName":"Ebay"},{"icon":"M127.6,292.2c-1.2-0.8-2-2-2-3.7c-2-20.4-19.1-36.6-39.9-36.6s-38.3,15.9-39.9,36.6c0,1.2-0.8,2.8-2,3.7  c-10.2,7.3-17.1,19.1-17.1,32.6c0,18.3,12.6,34.2,29.7,38.7l0,0c2.8,0.8,6.1,1.2,6.9,0.4c2-1.2,4.9-11.4,3.7-13.4  c-0.8-1.2-3.3-2.4-6.5-3.3l0,0c-10.2-2.8-17.5-11.8-17.5-22.8c0-6.1,2.4-11.4,6.1-15.9c1.6-2,3.7-3.7,6.1-4.9  c4.5-2.4,6.9-6.9,6.9-11.8l0,0c0-2.4,0.4-4.9,1.2-7.3c3.3-9.4,11.8-16.3,22.4-16.3s19.1,6.9,22.4,16.3c0.8,2.4,1.2,4.9,1.2,7.3l0,0  c0,4.9,2.4,9.4,6.9,11.8c2.4,1.2,4.1,2.8,6.1,4.9c3.7,4.1,6.1,9.8,6.1,15.9c0,13-10.6,23.6-23.6,23.6c-15.1,0-26.9,12.2-26.9,27.3  v15.5c0,2.8,0.4,6.1,1.2,6.9c1.6,1.6,12.2,1.6,13.8,0c0.8-0.8,1.2-4.1,1.2-6.9l0,0v-15.9c0-5.7,4.9-10.6,10.6-10.6  c22,0,39.9-17.9,39.9-39.9C144.7,311.4,137.8,299.6,127.6,292.2z","id":4,"shortName":"Amazon"},{"icon":"M127.6,292.2c-1.2-0.8-2-2-2-3.7c-2-20.4-19.1-36.6-39.9-36.6s-38.3,15.9-39.9,36.6c0,1.2-0.8,2.8-2,3.7  c-10.2,7.3-17.1,19.1-17.1,32.6c0,18.3,12.6,34.2,29.7,38.7l0,0c2.8,0.8,6.1,1.2,6.9,0.4c2-1.2,4.9-11.4,3.7-13.4  c-0.8-1.2-3.3-2.4-6.5-3.3l0,0c-10.2-2.8-17.5-11.8-17.5-22.8c0-6.1,2.4-11.4,6.1-15.9c1.6-2,3.7-3.7,6.1-4.9  c4.5-2.4,6.9-6.9,6.9-11.8l0,0c0-2.4,0.4-4.9,1.2-7.3c3.3-9.4,11.8-16.3,22.4-16.3s19.1,6.9,22.4,16.3c0.8,2.4,1.2,4.9,1.2,7.3l0,0  c0,4.9,2.4,9.4,6.9,11.8c2.4,1.2,4.1,2.8,6.1,4.9c3.7,4.1,6.1,9.8,6.1,15.9c0,13-10.6,23.6-23.6,23.6c-15.1,0-26.9,12.2-26.9,27.3  v15.5c0,2.8,0.4,6.1,1.2,6.9c1.6,1.6,12.2,1.6,13.8,0c0.8-0.8,1.2-4.1,1.2-6.9l0,0v-15.9c0-5.7,4.9-10.6,10.6-10.6  c22,0,39.9-17.9,39.9-39.9C144.7,311.4,137.8,299.6,127.6,292.2z","id":5,"shortName":"Bonanza"}]}

/***/ }),

/***/ 201:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchFilter_vue__ = __webpack_require__(92);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1708c122_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchFilter_vue__ = __webpack_require__(202);
var normalizeComponent = __webpack_require__(23)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1708c122_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 202:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":"searchProviders"}},[_vm._v("Aðilar")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchFilter.SearchProviders),expression:"searchFilter.SearchProviders"}],staticClass:"form-control",attrs:{"id":"searchProviders","multiple":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.searchFilter, "SearchProviders", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.providers),function(option){return _c('option',{key:option.id,domProps:{"value":option.id}},[_vm._v("\n            "+_vm._s(option.ShortName)+"\n          ")])}))])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":"PageSize"}},[_vm._v("Fjöldi á síðu")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchFilter.PageSize),expression:"searchFilter.PageSize"}],staticClass:"form-control",attrs:{"id":"PageSize","type":"number"},domProps:{"value":(_vm.searchFilter.PageSize)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.searchFilter, "PageSize", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":"MinPrice"}},[_vm._v("Lágmarksverð")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchFilter.MinPrice),expression:"searchFilter.MinPrice"}],staticClass:"form-control",attrs:{"id":"MinPrice","type":"number"},domProps:{"value":(_vm.searchFilter.MinPrice)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.searchFilter, "MinPrice", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":"MaxPrice"}},[_vm._v("Hámarksverð")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchFilter.MaxPrice),expression:"searchFilter.MaxPrice"}],staticClass:"form-control",attrs:{"id":"MaxPrice","type":"number"},domProps:{"value":(_vm.searchFilter.MaxPrice)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.searchFilter, "MaxPrice", $event.target.value)}}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 203:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 204:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:[_vm.loading ? '' : 'd-none', 'loading'],attrs:{"id":"search-loading"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search"},[_c('div',{staticClass:"search-form mx-auto my-3"},[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.handleSearch($event)}}},[_c('div',{staticClass:"input-group mb-3"},[_c('input',{directives:[{name:"focus",rawName:"v-focus"},{name:"model",rawName:"v-model",value:(_vm.filterObject.K),expression:"filterObject.K"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Leita...","autocomplete":"off"},domProps:{"value":(_vm.filterObject.K)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filterObject, "K", $event.target.value)}}}),_vm._v(" "),_vm._m(0)])])]),_vm._v(" "),_c('div',{staticClass:"result-items row"},_vm._l((_vm.results),function(res){return _c('div',{key:res.id,staticClass:"col-sm result-col border rounded"},[_c('div',{staticClass:"thumbnail result-item"},[_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal.productDetail",modifiers:{"productDetail":true}}],on:{"click":function($event){_vm.popUp(res)}}},[_c('b-img-lazy',{staticClass:"border mx-auto d-block",attrs:{"src":(res.images != null && res.images[2] != null) ? res.images[2] : res.image,"width":"200","height":"200","blank-color":"#bbb","alt":"Engin mynd"}}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(res.title)}})],1)])])})),_vm._v(" "),_c('Loader',{attrs:{"loading":_vm.loading}}),_vm._v(" "),_c('b-modal',_vm._b({attrs:{"id":"productDetail","title":"Nánar um vöru","size":"lg","cancel-title":"Hætta við","ok-title":"Kaupa"},on:{"ok":function($event){_vm.openLink()},"lazy":true,"centered":true}},'b-modal',_vm.$props,false),[_c('Detail',{attrs:{"product":_vm.product}})],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"fas fa-search"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 206:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 207:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.product.loading)?_c('div',[_c('Loader',{attrs:{"loading":_vm.product.loading}})],1):_c('div',[_c('b-card',{staticClass:"text-left",attrs:{"bg-variant":"default","text-variant":"black","header":"Upplýsingar"}},[_c('b-row',[_c('b-col',[_vm._v("Lýsing")]),_vm._v(" "),_c('b-col',{domProps:{"innerHTML":_vm._s(_vm.product.title)}})],1),_vm._v(" "),(_vm.product.originalPrice)?_c('b-row',[_c('b-col',[_vm._v("Verð án afsláttar")]),_vm._v(" "),_c('b-col',[_vm._v(_vm._s(_vm.product.originalPrice)+" "+_vm._s(_vm.product.currencyCode))])],1):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',[_vm._v("Verð")]),_vm._v(" "),_c('b-col',[_vm._v(_vm._s(_vm.product.salePrice)+" "+_vm._s(_vm.product.currencyCode))])],1)],1),_vm._v(" "),_c('div',{staticClass:"result-items row"},_vm._l((_vm.product.images),function(res){return _c('div',{key:res.id,staticClass:"col-sm result-col rounded"},[_c('div',{staticClass:"thumbnail result-item"},[_c('b-img-lazy',{staticClass:"border mx-auto d-block",attrs:{"src":res,"width":"200","height":"200","blank-color":"#bbb","alt":"img"}})],1)])}))],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 209:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 213:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 243:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 260:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 307:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 313:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_searchFilter__ = __webpack_require__(314);



// import createLogger from '@/plugins/logger'

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    searchFilter: __WEBPACK_IMPORTED_MODULE_2__modules_searchFilter__["a" /* default */]
  },
  strict: debug
}));

/***/ }),

/***/ 314:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_productApi__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_currencyApi__ = __webpack_require__(319);


var _mutations;




var UPDATE_FILTER = 'UPDATE_FILTER';
var SET_PROVIDERS = 'SET_PROVIDERS';
var SET_CURRENCIES = 'SET_CURRENCIES';
var SET_LOADING = 'SET_LOADING';

// initial state
var state = {
  filter: {},
  providers: [],
  currencies: [],
  loading: false

  // getters
};var getters = {
  filter: function filter(state) {
    return state.filter;
  },
  providers: function providers(state) {
    return state.providers;
  },
  loading: function loading(state) {
    return state.loading;
  }

  // actions
};var actions = {
  getCurrencies: function getCurrencies(_ref) {
    var commit = _ref.commit;

    commit(SET_LOADING, true);
    __WEBPACK_IMPORTED_MODULE_2__api_currencyApi__["a" /* default */].getCurrencies().then(function (response) {
      commit(SET_CURRENCIES, response.data.results);
      commit(SET_LOADING, false);
    });
  },
  getProviders: function getProviders(_ref2) {
    var commit = _ref2.commit;

    commit(SET_LOADING, true);
    __WEBPACK_IMPORTED_MODULE_1__api_productApi__["a" /* default */].getProviders().then(function (response) {
      commit(SET_PROVIDERS, response.data);
      commit(SET_LOADING, false);
    });
  },
  isLoading: function isLoading(_ref3, _isLoading) {
    var commit = _ref3.commit,
        state = _ref3.state;

    commit(SET_LOADING, _isLoading);
  }
};

// mutations
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, UPDATE_FILTER, function (state, filter) {
  state.filter = filter;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, SET_LOADING, function (state, loading) {
  state.loading = loading;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, SET_PROVIDERS, function (state, providers) {
  state.providers = providers;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, SET_CURRENCIES, function (state, currencies) {
  state.currencies = currencies;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 319:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_mock_currencyMockApi__ = __webpack_require__(320);



var url = "https://apis.is/currency";

var currencyApi = {
  getCurrencies: function getCurrencies() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url + '/lb') // more providers available for example m5
    .catch(function (error) {
      console.error(error);
    });
  }
};

var api = currencyApi;
try {
  var useMock = "production" === 'development' && Object({"NODE_ENV":"production","API_SEARCH_URL":'https://test-api.fjarkaup.is/SearchService/products/search',"API_PRODUCT_URL":'https://test-api.fjarkaup.is/ProductService',"API_CURRENCY_URL":"https://apis.is/currency"}).API_USE_MOCK === true;
  api = useMock ? __WEBPACK_IMPORTED_MODULE_1__api_mock_currencyMockApi__["a" /* default */] : currencyApi;
} catch (e) {
  console.error('error!');
}

/* harmony default export */ __webpack_exports__["a"] = (api);

/***/ }),

/***/ 320:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_currencyResult__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_currencyResult___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__data_currencyResult__);



var delay = function delay(ms) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    return setTimeout(resolve, ms);
  });
};
var shouldReject = false;

/* harmony default export */ __webpack_exports__["a"] = ({
  getCurrencies: function getCurrencies() {
    console.info('** getCurrencies mock **');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      delay(1000).then(function () {
        if (shouldReject) {
          console.error('rejected', reject);
        } else {
          return resolve(__WEBPACK_IMPORTED_MODULE_1__data_currencyResult___default.a);
        }
      });
    });
  }
});

/***/ }),

/***/ 321:
/***/ (function(module, exports) {

module.exports = {"data":{"results":[{"shortName":"EUR","longName":"Evra","value":123.19999999999999,"askValue":123.58,"bidValue":122.82,"changeCur":0.32,"changePer":0},{"shortName":"USD","longName":"Bandaríkjadalur","value":104.59,"askValue":104.91,"bidValue":104.27,"changeCur":1.06,"changePer":0.01},{"shortName":"GBP","longName":"Sterlingspund","value":140.985,"askValue":141.42,"bidValue":140.55,"changeCur":0.8,"changePer":0.01},{"shortName":"JPY","longName":"Japanskt jen","value":0.94835,"askValue":0.9513,"bidValue":0.9454,"changeCur":1,"changePer":1.05},{"shortName":"NOK","longName":"Norsk króna","value":12.8865,"askValue":12.926,"bidValue":12.847,"changeCur":0.77,"changePer":0.06},{"shortName":"SEK","longName":"Sænsk króna","value":11.9865,"askValue":12.025,"bidValue":11.948,"changeCur":0.34,"changePer":0.03},{"shortName":"DKK","longName":"Dönsk króna","value":16.54,"askValue":16.591,"bidValue":16.489,"changeCur":0.31,"changePer":0.02},{"shortName":"CHF","longName":"Svissneskur franki","value":104.505,"askValue":104.83,"bidValue":104.18,"changeCur":0.96,"changePer":0.01},{"shortName":"CAD","longName":"Kanadadalur","value":81.545,"askValue":81.8,"bidValue":81.29,"changeCur":1.38,"changePer":0.02},{"shortName":"AUD","longName":"Ástralskur dalur","value":78.43,"askValue":78.71,"bidValue":78.15,"changeCur":1.33,"changePer":0.02},{"shortName":"ZAR","longName":"Suður-Afrískt rand","value":8.3885,"askValue":8.419,"bidValue":8.358,"changeCur":1.81,"changePer":0.22},{"shortName":"HKD","longName":"Hong Kong dalur","value":13.3235,"askValue":13.372,"bidValue":13.275,"changeCur":1.05,"changePer":0.08},{"shortName":"NZD","longName":"Nýsjálenskur dalur","value":72.055,"askValue":72.32,"bidValue":71.79,"changeCur":1.23,"changePer":0.02},{"shortName":"XDR","longName":"SDR-sérstök DDR","value":148.67000000000002,"askValue":149.19,"bidValue":148.15,"changeCur":0.8,"changePer":0.01},{"shortName":"PLN","longName":"Pólskt zloty","value":28.779,"askValue":28.889,"bidValue":28.669,"changeCur":0.67,"changePer":0.02},{"shortName":"RUB","longName":"Rússnesk rúbla","value":1.6895,"askValue":1.6963,"bidValue":1.6827,"changeCur":1.76,"changePer":1.04},{"shortName":"SGD","longName":"Singapore dollar","value":77.945,"askValue":78.27,"bidValue":77.62,"changeCur":1.12,"changePer":0.01},{"shortName":"CNY","longName":"Kínverskt Yuan","value":16.415,"askValue":16.484,"bidValue":16.346,"changeCur":1.15,"changePer":0.07},{"shortName":"GVT","longName":"Gengisvísitalan","value":161.26,"askValue":161.39,"bidValue":161.13,"changeCur":0.6,"changePer":0}]}}

/***/ }),

/***/ 63:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ 64:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_searchApi__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_productApi__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SearchFilter__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Loader__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(37);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Search',
  data: function data() {
    return {
      bottom: false,
      noMoreResults: false,
      results: [],
      product: {},
      filterObject: {
        P: [1, 2, 3],
        // P: 3,
        OF: 'Price',
        OD: 'Descending',
        S: 20,
        N: 1,
        M: 1000,
        C: 10,
        R: 'Asia',
        K: '',
        D: false,
        X: 3000
      }
    };
  },

  components: {
    'SearchFilter': __WEBPACK_IMPORTED_MODULE_4__components_SearchFilter__["a" /* default */],
    'Loader': __WEBPACK_IMPORTED_MODULE_5__components_Loader__["a" /* default */]
  },
  created: function created() {
    var _this = this;

    this.$store.dispatch('getProviders');
    // this.$store.dispatch('getCurrencies')
    this.$store.dispatch('isLoading');
    window.addEventListener('scroll', function () {
      _this.bottom = _this.bottomVisible();
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])(['providers', 'currencies', 'loading'])),
  watch: {
    bottom: function bottom(_bottom) {
      if (_bottom) {
        this.addToResults();
      }
    }
  },
  methods: {
    setLoading: function setLoading(isLoading) {
      this.$store.dispatch('isLoading', isLoading);
    },
    handleSearch: function handleSearch() {
      var _this2 = this;

      this.results = [];
      // TODO: loop through results and convert to numbers
      // this.filterObject.SearchProviders = [1, 2, 3, 4]
      this.setLoading(true);
      __WEBPACK_IMPORTED_MODULE_2__api_searchApi__["a" /* default */].search(this.filterObject).then(function (response) {
        _this2.setLoading(false);
        _this2.results = response.data;
      }).catch(function (err) {
        console.error('error', err);
        this.setLoading(false);
      });
    },
    openLink: function openLink() {
      window.open(this.product.url, '_blank');
    },
    popUp: function popUp(product) {
      var _this3 = this;

      this.product = product;
      this.product.loading = true;
      __WEBPACK_IMPORTED_MODULE_3__api_productApi__["a" /* default */].getProduct(product.id, product.providerId).then(function (response) {
        _this3.product = response.data;
        _this3.product.loading = false;
      });
    },
    bottomVisible: function bottomVisible() {
      var scrollY = window.scrollY;
      var visible = document.documentElement.clientHeight;
      var pageHeight = document.documentElement.scrollHeight;
      var bottomOfPage = visible + scrollY >= pageHeight;
      return bottomOfPage || pageHeight < visible;
    },
    addToResults: function addToResults() {
      var _this4 = this;

      this.setLoading(true);
      this.filterObject.N += 1;
      __WEBPACK_IMPORTED_MODULE_2__api_searchApi__["a" /* default */].search(this.filterObject).then(function (response) {
        var _results;

        _this4.setLoading(false);
        if (response.data.length === 0) {
          _this4.noMoreResults = true;
        }
        (_results = _this4.results).push.apply(_results, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(response.data));
        setTimeout(function () {
          if (_this4.bottomVisible() && !_this4.noMoreResults) {
            _this4.addToResults();
          }
        }, 1000);
      }).catch(function (err) {
        console.error('error', err);
        this.setLoading(false);
      });
    }
  }
});

/***/ }),

/***/ 91:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_mock_productMockApi__ = __webpack_require__(198);


var url = 'https://test-api.fjarkaup.is/ProductService';

var productApi = {
  getProduct: function getProduct(productId, providerId) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url + '/products/' + productId + '/provider/' + providerId).catch(function (error) {
      console.error(error);
    });
  },
  getProviders: function getProviders() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url + '/providers');
  }
};

var api = productApi;
try {
  var useMock = "production" === 'development' && Object({"NODE_ENV":"production","API_SEARCH_URL":'https://test-api.fjarkaup.is/SearchService/products/search',"API_PRODUCT_URL":'https://test-api.fjarkaup.is/ProductService',"API_CURRENCY_URL":"https://apis.is/currency"}).API_USE_MOCK === true;
  api = useMock ? __WEBPACK_IMPORTED_MODULE_1__api_mock_productMockApi__["a" /* default */] : productApi;
} catch (e) {
  console.error('error!');
}

/* harmony default export */ __webpack_exports__["a"] = (api);

/***/ }),

/***/ 92:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SearchFilter',
  props: ['searchFilter', 'providers'],
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 93:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue__ = __webpack_require__(94);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92257640_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__ = __webpack_require__(204);
function injectStyle (ssrContext) {
  __webpack_require__(203)
}
var normalizeComponent = __webpack_require__(23)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-92257640"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92257640_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 94:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Loader',
  props: ['loading'],
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 95:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Detail_vue__ = __webpack_require__(96);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e105850a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Detail_vue__ = __webpack_require__(207);
function injectStyle (ssrContext) {
  __webpack_require__(206)
}
var normalizeComponent = __webpack_require__(23)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e105850a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e105850a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 96:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loader__ = __webpack_require__(93);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'detail',
  props: ['product'],
  data: function data() {
    return {};
  },

  components: {
    'Loader': __WEBPACK_IMPORTED_MODULE_0__components_Loader__["a" /* default */]
  }
});

/***/ })

},[126]);


// WEBPACK FOOTER //
// static/js/app.d61b05e349987d0b33a7.js